import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart, Package, Sparkles } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: <ShoppingCart size={32} className="text-[#1B5E20]" data-id="element-126" />,
    title: 'Elige Tu Paquete',
    description: 'Selecciona el sistema que mejor se adapta a tus necesidades'
  }, {
    icon: <Package size={32} className="text-[#1B5E20]" data-id="element-127" />,
    title: 'Recíbelo En Casa',
    description: 'Envío directo a tu puerta en USA. Gratis en pedidos de $141+'
  }, {
    icon: <Sparkles size={32} className="text-[#1B5E20]" data-id="element-128" />,
    title: 'Siente Los Resultados',
    description: 'En 30 días notarás cambios reales. Recibirás asesoría y seguimiento por WhatsApp para guiarte en todo el proceso'
  }];
  return <section id="como-funciona" className="py-24 bg-white" data-id="element-129">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-130">
        <div className="text-center mb-20" data-id="element-131">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-serif font-bold text-[#1A1A1A]" data-id="element-132">
            Así Funciona Tu Transformación
          </motion.h2>
        </div>

        <div className="relative max-w-5xl mx-auto" data-id="element-133">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-gray-200 border-t-2 border-dashed border-gray-300 z-0" data-id="element-134"></div>

          <div className="grid md:grid-cols-3 gap-12 relative z-10" data-id="element-135">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="flex flex-col items-center text-center" data-id="element-136">
                <div className="w-24 h-24 bg-[#FAFAF7] rounded-full flex items-center justify-center shadow-sm border border-gray-100 mb-8 relative" data-id="element-137">
                  <div className="absolute -top-2 -right-2 w-8 h-8 bg-[#F9A825] text-[#1A1A1A] rounded-full flex items-center justify-center font-black text-sm shadow-sm" data-id="element-138">
                    {index + 1}
                  </div>
                  {step.icon}
                </div>
                <h3 className="text-xl font-bold text-[#1A1A1A] mb-3" data-id="element-139">
                  {step.title}
                </h3>
                <p className="text-gray-600 max-w-xs" data-id="element-140">{step.description}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}